const TRIGGER_SELECTOR = 'a[href="#watch-review"]';
const MODAL_ID = '#video-modal';

/** @type {any} */
let player = null;
let apiLoading = false;
let apiReady = false;
let pendingPlay = false;

function loadYouTubeApi() {
  if (apiLoading || apiReady) return;
  apiLoading = true;

  window.onYouTubeIframeAPIReady = () => {
    apiReady = true;
    if (pendingPlay) createPlayer();
  };

  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
}

function createPlayer() {
  const modal = document.querySelector(MODAL_ID);
  if (!modal || player || !window.YT || !window.YT.Player) return;

  const mount = modal.querySelector('[data-yt-player]');
  const videoId = modal.getAttribute('data-video-id');
  if (!mount || !videoId) return;

  const autoplay = modal.getAttribute('data-autoplay') === 'true';

  player = new window.YT.Player(mount, {
    videoId,
    playerVars: {
      rel: 0,
      autoplay: autoplay ? 1 : 0,
    },
    events: {
      onReady(event) {
        if (autoplay) event.target.playVideo();
      },
    },
  });

  pendingPlay = false;
}

function playVideo() {
  if (!apiReady) {
    pendingPlay = true;
    loadYouTubeApi();
    return;
  }

  if (!player) {
    createPlayer();
    return;
  }

  player.seekTo(0);
  player.playVideo();
}

function stopVideo() {
  if (player && typeof player.pauseVideo === 'function') {
    player.pauseVideo();
  }
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest(TRIGGER_SELECTOR);
  if (!trigger) return;

  event.preventDefault();

  const modal = /** @type {any} */ (document.querySelector(MODAL_ID));
  if (!modal || typeof modal.showDialog !== 'function') return;

  modal.showDialog();
  playVideo();
});

const modalElement = document.querySelector(MODAL_ID);
if (modalElement) {
  // DialogOpenEvent/DialogCloseEvent don't bubble, so listen on the
  // component itself rather than delegating from `document`.
  modalElement.addEventListener('dialog:close', stopVideo);
}
